<template>
  <div>
    <rabbey-table-3
      show-summary
      :summary-method="getSummaries"
      :search="PaymenFilter"
      :data="reportData"
      :columns="reportColumns"
      :actions="reportActions"
      :loading="reportDataLoading"
    />
  </div>
</template>

<script>
import { columns } from "@/components/fiances/reports/table/columns/PaymentAndInvoicingReportColumns";
import { formatterMoney } from "@/utils";

export default {
  name: "PaymentAndInvoicingReportTable",
  props: {
    TabSelected: {
      type: String,
      defaul: "",
      required: true
    },
    YearSelected: {
      type: Number,
      default: 0,
      required: false
    },
    MonthSelected: {
      type: Number,
      default: 0,
      required: false
    },
    PaymentTypeSelected: {
      type: Number,
      default: 0,
      required: false
    },
    PaymentSelected: {
      type: String,
      default: "",
      required: false
    },
    ExecutionSelected: {
      type: Boolean,
      default: null,
      required: false
    },
    InvoiceType: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      reportData: [],
      reportColumns: columns(this),
      reportActions: [],
      reportDataLoading: false
    };
  },

  // mounted() {
  //   this.GetReportData();
  // },
  computed: {
    ActualTabValue() {
      return this.TabSelected;
    },
    YearFilter() {
      return this.YearSelected;
    },
    MonthFilter() {
      return this.MonthSelected;
    },
    PaymentTypeFilter() {
      return this.PaymentTypeSelected;
    },
    PaymenFilter() {
      return this.PaymentSelected;
    },
    ExecutionFilter() {
      return this.ExecutionSelected;
    },
    InvoiceTypeFilter() {
      return this.InvoiceType;
    }
  },
  methods: {
    formatterMoney,
    async GetReportData() {
      this.reportDataLoading = true;

      const body = {
        params: {
          Year: this.YearFilter,
          Month: this.MonthFilter,
          PaymentType: this.PaymentTypeFilter,
          isExecuted: this.ExecutionFilter,
          invoiceType: this.InvoiceTypeFilter
        }
      };

      await this.$http
        .get("/api/CalendarioFinanza/GetInvoicesAndPaymentsReport", body)
        .then((resp) => {
          this.reportData = resp.data;
        })
        .catch((err) => {
          this.$$message.error(err);
        })
        .finally(() => {
          this.reportDataLoading = false;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total por Mes";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));

        if (!values.every((value) => isNaN(value))) {
          let valor = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.formatterMoney(valor);
        } else {
          sums[index] = "";
        }
      });

      return sums;
    }
  },
  watch: {
    ActualTabValue(val) {
      if (val === "report") this.GetReportData();
    },
    YearFilter() {
      this.GetReportData();
    },
    MonthFilter() {
      this.GetReportData();
    },
    PaymentTypeFilter() {
      this.GetReportData();
    },
    ExecutionFilter() {
      this.GetReportData();
    },
    InvoiceTypeFilter() {
      this.GetReportData();
    }
  }
};
</script>

<style scoped></style>
